import React, { useState } from 'react';
import { SmileIcon, XIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
type CreateChildAccountProps = {
  onClose: () => void;
  onSave: (childData: {
    name: string;
    avatar: string;
    age: number;
    readingLevel: 'beginner' | 'intermediate' | 'advanced';
  }) => void;
};
const AVATARS = ['🐰', '🦊', '🐼', '🦁', '🐯', '🐨', '👾', '🤖', '👻', '🦄', '🐉', '🦕'];
export const CreateChildAccount = ({
  onClose,
  onSave
}: CreateChildAccountProps) => {
  const [step, setStep] = useState<'info' | 'avatar' | 'preferences'>('info');
  const [name, setName] = useState('');
  const [age, setAge] = useState<number>(5);
  const [selectedAvatar, setSelectedAvatar] = useState('');
  const [readingLevel, setReadingLevel] = useState<'beginner' | 'intermediate' | 'advanced'>('beginner');
  const handleSave = () => {
    onSave({
      name,
      avatar: selectedAvatar,
      age,
      readingLevel
    });
  };
  const renderStep = () => {
    switch (step) {
      case 'info':
        return <div className="space-y-6" data-id="element-53">
            <div data-id="element-54">
              <label className="block text-purple-700 font-medium mb-2" data-id="element-55">
                Child's Name
              </label>
              <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full px-4 py-2 border border-purple-200 rounded-full focus:outline-none focus:border-purple-400 focus:ring-2 focus:ring-purple-100" placeholder="Enter name" data-id="element-56" />
            </div>
            <div data-id="element-57">
              <label className="block text-purple-700 font-medium mb-2" data-id="element-58">
                Age
              </label>
              <div className="flex items-center space-x-4" data-id="element-59">
                {[4, 5, 6, 7, 8, 9, 10].map(value => <button key={value} onClick={() => setAge(value)} className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${age === value ? 'bg-purple-600 text-white' : 'bg-purple-50 text-purple-700 hover:bg-purple-100'}`} data-id="element-60">
                    {value}
                  </button>)}
              </div>
            </div>
          </div>;
      case 'avatar':
        return <div className="space-y-6" data-id="element-61">
            <label className="block text-purple-700 font-medium mb-4" data-id="element-62">
              Choose an Avatar
            </label>
            <div className="grid grid-cols-4 gap-4" data-id="element-63">
              {AVATARS.map(avatar => <button key={avatar} onClick={() => setSelectedAvatar(avatar)} className={`aspect-square text-3xl rounded-xl border-2 transition-all ${selectedAvatar === avatar ? 'border-purple-600 bg-purple-50 scale-110' : 'border-purple-200 hover:border-purple-300'}`} data-id="element-64">
                  {avatar}
                </button>)}
            </div>
          </div>;
      case 'preferences':
        return <div className="space-y-6" data-id="element-65">
            <div data-id="element-66">
              <label className="block text-purple-700 font-medium mb-4" data-id="element-67">
                Reading Level
              </label>
              <div className="space-y-3" data-id="element-68">
                {[{
                value: 'beginner',
                label: 'Beginner (Ages 4-6)'
              }, {
                value: 'intermediate',
                label: 'Intermediate (Ages 6-8)'
              }, {
                value: 'advanced',
                label: 'Advanced (Ages 8-10)'
              }].map(level => <button key={level.value} onClick={() => setReadingLevel(level.value as typeof readingLevel)} className={`w-full p-4 rounded-xl border-2 text-left transition-colors ${readingLevel === level.value ? 'border-purple-600 bg-purple-50' : 'border-purple-200 hover:border-purple-300'}`} data-id="element-69">
                    <div className="font-medium text-purple-700" data-id="element-70">
                      {level.label}
                    </div>
                  </button>)}
              </div>
            </div>
          </div>;
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4" data-id="element-71">
      <div className="bg-white rounded-2xl w-full max-w-md p-6" data-id="element-72">
        <div className="flex items-center justify-between mb-6" data-id="element-73">
          <h2 className="text-xl font-bold text-purple-700" data-id="element-74">
            Add Child Account
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-purple-100 rounded-full transition-colors" data-id="element-75">
            <XIcon size={20} className="text-purple-700" data-id="element-76" />
          </button>
        </div>
        {renderStep()}
        <div className="flex justify-between mt-8" data-id="element-77">
          <button onClick={() => {
          if (step === 'avatar') setStep('info');
          if (step === 'preferences') setStep('avatar');
        }} className={`flex items-center px-4 py-2 rounded-full border-2 border-purple-200 text-purple-600 hover:bg-purple-50 transition-colors ${step === 'info' ? 'invisible' : ''}`} data-id="element-78">
            <ChevronLeftIcon size={20} className="mr-2" data-id="element-79" />
            Back
          </button>
          <button onClick={() => {
          if (step === 'info') setStep('avatar');else if (step === 'avatar') setStep('preferences');else handleSave();
        }} disabled={step === 'info' && !name || step === 'avatar' && !selectedAvatar} className="flex items-center px-6 py-2 bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-80">
            {step === 'preferences' ? 'Create Account' : <>
                Next
                <ChevronRightIcon size={20} className="ml-2" data-id="element-81" />
              </>}
          </button>
        </div>
      </div>
    </div>;
};